import Feature from 'Services/Feature';
const relatedTypeNotSupportedByNewPanel = [
    'delivery',
    'proforma'
]
window.Activities = {
    openActivityForm: function (activityId = null, relatedId = null, relatedType = null, callback = null, activityType, calendarId = null) {
        if (Feature.isEnabled('activity-new-creation-panel')) {
            if (activityType === 'event' && !Feature.isEnabled('activity-listing-crm-follow-up-deal-priotization-agenda-events')) {
                Agenda.editForm(activityId ?? '', calendarId ?? '', relatedId ?? '', relatedType ?? '', {}, activityType);
                return;
            }
            if (window.sellsyapp.config.globalProperties.$store.state.popupPanel.phoneCallFormPanel?.display) {
                Popup.closePopup('phoneCallFormPanel');
            }
            if (window.sellsyapp.config.globalProperties.$store.state.popupPanel.activityDetailPanel?.display) {
                Popup.closePopup('activityDetailPanel');
            }

            if(relatedType && relatedTypeNotSupportedByNewPanel.includes(relatedType)){
                Agenda.editForm(activityId ?? '', calendarId ?? '', relatedId ?? '', relatedType ?? '', {}, activityType);
                return;
            }

            const related = this.formatRelated(relatedId, relatedType);
            Popup.openPopup({key: 'activityFormPanel', props: {id: !!activityId ? +activityId : null, related, callback, activityType}});
        } else {
            Agenda.editForm(activityId ?? '', calendarId ?? '', relatedId ?? '', relatedType ?? '', {}, activityType);
        }
    },
    openPhoneCallForm: function (activityId = null, relatedId = null, relatedType = null, callback = null, scheduled = false) {
        if (Feature.isEnabled('activity-new-creation-panel')) {
            if (window.sellsyapp.config.globalProperties.$store.state.popupPanel.activityFormPanel?.display) {
                Popup.closePopup('activityFormPanel');
            }
            if (window.sellsyapp.config.globalProperties.$store.state.popupPanel.activityDetailPanel?.display) {
                Popup.closePopup('activityDetailPanel');
            }
            const related = this.formatRelated(relatedId, relatedType);
            Popup.openPopup({key: 'phoneCallFormPanel', props: {id: !!activityId ? +activityId : null, related, callback, scheduled}});
        } else {
            //We want to set null to let php manage if phonecall is done or not on legacy side
            const isDone = activityId ? null : !scheduled;
            PhoneCall.addCall(relatedId, relatedType, activityId ?? '0', this.refreshActivities, isDone);
        }
    },

    openNewActivityDetail: function (activityId, relatedId = null, relatedType = null, relatedSubType = null, activityType, callback = null, callbackOnDelete = null, callbackOnCreate = null) {
        if (window.sellsyapp.config.globalProperties.$store.state.popupPanel.activityFormPanel?.display) {
            Popup.closePopup('activityFormPanel');
        }
        if (window.sellsyapp.config.globalProperties.$store.state.popupPanel.phoneCallFormPanel?.display) {
            Popup.closePopup('phoneCallFormPanel');
        }

        const related = []
        if (+relatedId) { // cast to filter out id 0
            related.push({
                id: relatedId,
                type: relatedType,
                subtype: relatedSubType ?? relatedType,
            })
        }

        const activityDetailDisplayed = {
            id: activityId,
            type: activityType,
            related
        };
        Popup.openPopup({
            key: 'activityDetailPanel',
            props: {
                activityDetailDisplayed,
                shouldFetchAdditionalData: true,
                callback,
                callbackOnDelete,
                callbackOnCreate,
            }
        });
    },
    openOldTaskDetail: function(id, can_edit, date, relatedType) {
        Agenda.cardForm(
            id,
            0,
            'task',
            can_edit ? 'Y' : 'N',
            false,
            moment(date).unix(),
            moment(date).unix(),
            'N',
            relatedType
        );
    },

    formatRelated: function (relatedId, relatedType) {
        return !!relatedId ? {id: +relatedId, type: relatedType} : null;
    }
};
